import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/home";
import ImageIdentification from "./pages/imageIdentification";
function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route path="/" exact={true} component={Home} />
          <Route path="/imageIdentification" component={ImageIdentification} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
